<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from 'vuex';
import AlertError from '@/components/alert_error'
import { VueContentLoading } from 'vue-content-loading';
import QrCodeCard from '@/components/qr_code_card'

export default {
  page: {
    title: "استمارة قطع الاراضي والبدل النقدي - الشهيد",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading, QrCodeCard },
  data() {
    return {
      title: "تفاصيل الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/"
        },
        {
          text: "استمارة قطع الاراضي والبدل النقدي - الشهيد",
          href: "/plotsOfLand/martyrs",
        },
        {
          text: "التفاصيل",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      loadingContent: true,
      martyr: null,
      qrCodeContent: null,
      showAlert: false,
    };
  },
  computed:{
    ...mapGetters('plotsOfLandMartyr', ['getMartyr']),
  },
  methods: {
    ...mapActions('plotsOfLandMartyr', ['get']),
    handleError(error){
      alert(error)
      this.showAlert = true;
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    fetch(){
      this.get(this.id)
      .then(()=>{
        this.martyr = this.getMartyr
        this.loadingContent = false

        
        this.qrCodeContent = JSON.stringify({
          Id: this.martyr.qr_id,
          fullName: this.martyr.personal_info.full_name,
          date: this.martyr.created_at,
        });
      })
      .catch((error)=>{
        this.handleError(error)
        this.loadingContent = false
      })
    },
  },
  created(){
    this.fetch()
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadingContent = false;
    // }, 1000);
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">

        <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

        <div class="card">
          <div v-if="!loadingContent" class="card-body">
            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">البيانات الشخصية للشهيد</h5></div>
            <div class="row about-list">
              <h4>{{ martyr.personal_info.full_name }}</h4>
              <div class="col-md-4">
                <div class="media">
                  <label>اللقب :</label>
                  <p>{{ martyr.personal_info.family_name }}</p>
                </div>
                <div class="media">
                  <label>اسم الام الثلاثي :</label>
                  <p>{{ martyr.personal_info.mother_name }}</p>
                </div>
                <div class="media">
                  <label>تاريخ التولد :</label>
                  <p>{{ martyr.personal_info.birth_date }}</p>
                </div>
                <div class="media">
                  <label>الحالة الاجتماعية :</label>
                  <p>{{ martyr.personal_info.marital_status.title }}</p>
                </div>
                <div class="media">
                  <label>عدد الابناء :</label>
                  <p>{{ martyr.number_children }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>هل الاب على قيد الحياة :</label>
                  <p>{{ martyr.father_alive ? 'نعم' : 'لا' }}</p>
                </div>
                <div class="media">
                  <label>هل الام على قيد الحياة :</label>
                  <p>{{ martyr.mother_alive ? 'نعم' : 'لا' }}</p>
                </div>
                <div class="media">
                  <label>التحصيل الدراسي :</label>
                  <p>{{ martyr.personal_info.certificate.title }}</p>
                </div>
                <div class="media">
                  <label>الديانة :</label>
                  <p>{{ martyr.affiliation.religion.title }}</p>
                </div>
                <div class="media">
                  <label>القومية :</label>
                  <p>{{ martyr.affiliation.nationalism.title }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <!-- <div class="media">
                  <label>رقم الهاتف المستفيد 1 :</label>
                  <p>07702344344</p>
                </div>
                <div class="media">
                  <label>رقم الهاتف المستفيد 2 :</label>
                  <p>07702344344</p>
                </div> -->
                <div class="media">
                  <label> الرقم التقاعدي :</label>
                  <p>{{ martyr.retirement_number }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات الاستشهاد</h5></div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>تاريخ الاستشهاد :</label>
                  <p>{{ martyr.martyr_info.date_marty }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>محل الحادث :</label>
                  <p>{{ martyr.martyr_info.place_marty }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>التشكيل :</label>
                  <p>{{ martyr.martyr_info.dept }}</p>
                </div>
              </div>
            </div>

            
            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات المستفيدين</h5></div>
            <div class="con-beneficiary" v-for="(beneficiary, index) in martyr.beneficiaries" :key="beneficiary.id+'b'">
              <div class="row about-list">
                <h5 class="sub-title-beneficiary mb-1">المستفيد رقم : <b>{{ index + 1 }}</b></h5>
                <div class="row about-list mb-1">
                  <h4>{{ beneficiary.personal_info.full_name }}</h4>
                  <div class="col-md-4">
                    <div class="media">
                      <label>اللقب :</label>
                      <p>{{ beneficiary.personal_info.family_name }}</p>
                    </div>
                    <div class="media">
                      <label>اسم الام الثلاثي :</label>
                      <p>{{ beneficiary.personal_info.mother_name }}</p>
                    </div>
                    <div class="media">
                      <label>تاريخ التولد :</label>
                      <p>{{ beneficiary.personal_info.birth_date }}</p>
                    </div>
                    <div class="media">
                      <label>الحالة الاجتماعية :</label>
                      <p>{{ beneficiary.personal_info.marital_status.title }}</p>
                    </div>
                    <div class="media">
                      <label>عدد الابناء :</label>
                      <p>{{ beneficiary.number_children }}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="media">
                      <label>الجنس :</label>
                      <p>{{ beneficiary.personal_info.gender.title }}</p>
                    </div>
                    <div class="media">
                      <label>صلة القرابة :</label>
                      <p>{{ beneficiary.relative_relation.title }}</p>
                    </div>
                    <div class="media">
                      <label>التحصيل الدراسي :</label>
                      <p>{{ beneficiary.personal_info.certificate.title }}</p>
                    </div>
                    <div class="media">
                      <label> التخصص الدراسي :</label>
                      <p>{{ beneficiary.personal_info.specialization }}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="media">
                      <label>رقم الهاتف 1 :</label>
                      <p>{{ beneficiary.personal_info.phone1 }}</p>
                    </div>
                    <div class="media">
                      <label>رقم الهاتف 2 :</label>
                      <p>{{ beneficiary.personal_info.phone2 }}</p>
                    </div>
                    <div class="media">
                      <label>رقم البطاقة الوطنية :</label>
                      <p>{{ beneficiary.personal_info.nationality_number }}</p>
                    </div>
                    <div class="media">
                      <label>هوية الاحول المدنية :</label>
                      <p>{{ beneficiary.personal_info.national_id_number }}</p>
                    </div>
                    <div class="media">
                      <a :href="beneficiary.attachment.url_basic" target="_blank">
                        <b-button :disabled="!beneficiary.attachment.url_basic" variant="primary" type="button" class="me-2"
                        >المرفقات الثبوتية للمستفيد</b-button
                        >
                      </a>
                    </div>
                  </div>
                </div>
                <div class="row about-list">
                  <h5 class="mb-1">معلومات السكن للمستفيد</h5>
                  <div class="col-md-4">
                    <div class="media">
                      <label>نوع السكن :</label>
                      <p>{{ beneficiary.address.accommodation.title }}</p>
                    </div>
                    <div class="media">
                      <label>المحافظة :</label>
                      <p>{{ beneficiary.address.city.title }}</p>
                    </div>
                    <div class="media">
                      <label>المنطقة :</label>
                      <p>{{ beneficiary.address.region }}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="media">
                      <label>اقرب نقطة دالة :</label>
                      <p>{{ beneficiary.address.nearest_point }}</p>
                    </div>
                    <div class="media">
                      <label>المحلة :</label>
                      <p>{{ beneficiary.address.mahla }}</p>
                    </div>
                    <div class="media">
                      <label>الزقاق :</label>
                      <p>{{ beneficiary.address.zqaq }}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="media">
                      <label>الدار :</label>
                      <p>{{ beneficiary.address.dar }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <hr class="hr-title" />
              <div class="break-title"><h5 class="mb-2">قطع الاراضي</h5></div>
              <h5 class="mt-3 sub-title" v-if="beneficiary.earth_sections.length == 0">لم يستلم قطعة ارض</h5>
              <div class="row about-list" v-else v-for="(earth_section, eindex) in beneficiary.earth_sections" :key="earth_section.id+'e'">
                <h5 class="sub-title mb-1">القطعة رقم : <b>{{ eindex + 1 }}</b></h5>
                <div class="col-md-4">
                  <div class="media">
                    <label>الجهة المانحة :</label>
                    <p>{{ earth_section.grant_name }}</p>
                  </div>
                  <div class="media">
                    <label> رقم القطعة :</label>
                    <p>{{ earth_section.section_number }}</p>
                  </div>
                  <div class="media">
                    <label> نوع الملك :</label>
                    <p>{{ earth_section.accommodation.title }}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="media">
                    <label> مساحة القطعة :</label>
                    <p>{{ earth_section.area_section }}</p>
                  </div>
                  <div class="media">
                    <label> المحافظة :</label>
                    <p>{{ earth_section.city.title }}</p>
                  </div>
                  <div class="media">
                    <label> القضاء :</label>
                    <p>{{ earth_section.district }}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="media">
                    <label> الحي :</label>
                    <p>{{ earth_section.sub_district }}</p>
                  </div>
                  <div class="media">
                    <a :href="earth_section.attachment.url" target="_blank">
                      <b-button :disabled="!earth_section.attachment.url" variant="primary" type="button" class="me-2"
                      >مرفق سند الملكية</b-button
                      >
                    </a>
                  </div>
                </div>
              </div>

              <hr class="hr-title" />
              <div class="break-title"><h5 class="mb-2">البدل النقدي</h5></div>
              <h5 class="mt-3 sub-title" v-if="beneficiary.moneys_replaces.length == 0">لم يستلم بدل نقدي</h5>
              <div class="row about-list" v-else v-for="(money_replace, mindex) in beneficiary.moneys_replaces" :key="money_replace.id+'m'">
                <h5 class="sub-title mb-1">البدل النقدي رقم : <b>{{ mindex + 1 }}</b></h5>
                <div class="col-md-6">
                  <div class="media">
                    <label>الجهة المانحة :</label>
                    <p>{{ money_replace.grant_name }}</p>
                  </div>
                  <div class="media">
                    <label> تاريخ الاستلام :</label>
                    <p>{{ money_replace.received_date }}</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="media">
                    <label> المبلغ المستلم :</label>
                    <p>{{ money_replace.ammont }}</p>
                  </div>
                  <div class="media">
                    <a :href="money_replace.attachment.url" target="_blank">
                      <b-button :disabled="!money_replace.attachment.url" variant="primary" type="button" class="me-2"
                      >مرفق البدل النقدي</b-button
                      >
                    </a>
                  </div>
                </div>
              </div>

              <hr class="hr-title" />
              <div class="break-title"><h5 class="mb-2">منح البناء</h5></div>
              <h5 class="mt-3 sub-title" v-if="beneficiary.builds_replace.length == 0">لم يستلم اي منحة بناء</h5>
              <div class="row about-list" v-else v-for="(build_replace, bindex) in beneficiary.builds_replace" :key="build_replace.id+'b'">
                <h5 class="sub-title mb-1">منحة البناء رقم : <b>{{ bindex + 1 }}</b></h5>
                <div class="col-md-4">
                  <div class="media">
                    <label>الجهة المانحة :</label>
                    <p>{{ build_replace.grant_name }}</p>
                  </div>
                  <div class="media">
                    <label> رقم القطعة :</label>
                    <p>{{ build_replace.section_number }}</p>
                  </div>
                  <div class="media">
                    <label> تاريخ الاستلام :</label>
                    <p>{{ build_replace.received_date }}</p>
                  </div>
                  <div class="media">
                    <label> نوع الملك :</label>
                    <p>{{ build_replace.accommodation.title }}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="media">
                    <label> المبلغ المستلم :</label>
                    <p>{{ build_replace.ammont }}</p>
                  </div>
                  <div class="media">
                    <label> مساحة القطعة :</label>
                    <p>{{ build_replace.area_section }}</p>
                  </div>
                  <div class="media">
                    <label> المحافظة :</label>
                    <p>{{ build_replace.city.title }}</p>
                  </div>
                  <div class="media">
                    <label> القضاء :</label>
                    <p>{{ build_replace.district }}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="media">
                    <label> الحي :</label>
                    <p>{{ build_replace.sub_district }}</p>
                  </div>
                  <div class="media">
                    <a :href="build_replace.attachment.url" target="_blank">
                      <b-button :disabled="!build_replace.attachment.url" variant="primary" type="button" class="me-2"
                      >مرفق منحة البناء</b-button
                      >
                    </a>
                  </div>
                </div>
              </div>

            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">تنزيل المرفقات</h5></div>
            <div class="row about-list">
              <div class="col-md-12">
                <a :href="martyr.attachment.url_qssam" target="_blank">
                  <b-button :disabled="!martyr.attachment.url_qssam" variant="primary" type="button" class="me-2"
                  >مرفق القسام الشرعي</b-button
                  >
                </a>
                <a :href="martyr.attachment.url_info" target="_blank">
                  <b-button :disabled="!martyr.attachment.url_info" variant="primary" type="button" class="me-2"
                  >مرفق تأييد الاستشهاد</b-button
                  >
                </a>
              </div>
            </div>

            
            <QrCodeCard 
                title="استمارة اطفاء القروض الحكومية"
                :fullName="this.martyr.personal_info.full_name"
                :date="this.martyr.created_at"
                :Id="this.martyr.qr_id"
                :qrCodeContent="this.qrCodeContent"
              ></QrCodeCard>

            <div class="mt-3">
              <hr />
              <b-button class="" type="button" to="/plotsOfLand/martyrs" variant="secondary"
                >رجوع</b-button
              >
            </div>
          </div>

                <!-- loading content -->
                <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="110">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />

              <rect x="10" y="25" rx="1" ry="1" width="50" height="5" />
              <rect x="340" y="25" rx="1" ry="1" width="50" height="5" />

              <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />
              <circle cx="340" cy="100" r="1" />
              <circle cx="350" cy="100" r="1" />
              <circle cx="363" cy="100" r="4" />
              <circle cx="376" cy="100" r="1" />
              <circle cx="386" cy="100" r="1" />
              
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>
